<script setup lang="ts">
// Sierra's .empty: a dashed outline round one sentence (`title`), an optional second
// line, and an optional action in the default slot.
defineProps<{ title: string; body?: string }>();
</script>

<template>
  <div class="itc-empty itc-empty-state">
    <div class="itc-empty-state__title">{{ title }}</div>
    <div v-if="body" class="itc-empty-state__body">{{ body }}</div>
    <div v-if="$slots.default" class="itc-empty-state__action"><slot /></div>
  </div>
</template>

<style scoped>
.itc-empty-state__body {
  margin-top: 4px;
  font-size: 14px;
}
.itc-empty-state__action {
  display: flex;
  justify-content: center;
  margin-top: var(--itc-s3);
}
</style>
